import { BaseButton, BaseCheckBox, BasePlate, BasePlateHeader } from '@evrone-erp/uikit';
import type { ITotpPlateProps } from '@widgets/totp/lib/types';
import { useTranslation } from 'next-i18next';
import React, { useMemo } from 'react';

export const TotpPlate = ({ otpEnabled, onChangeOtp, isLoading = false }: ITotpPlateProps) => {
  const { t } = useTranslation(['account', 'translation']);
  const sx = useMemo(
    () => ({
      color: otpEnabled ? 'error.dark' : 'success.main',
      borderColor: otpEnabled ? 'error.dark' : 'success.main',
    }),
    [otpEnabled],
  );

  return (
    <BasePlate sx={{ height: '100%', alignItems: 'flex-start' }} loading={isLoading}>
      <BasePlateHeader title={t('account:2FA')} />
      <div>
        <BaseCheckBox value={otpEnabled} label={t('account:2FAEnabled')} disabled />
        <BaseButton variant="outlined" sx={sx} icon={otpEnabled ? 'delete' : 'choice'} onClick={onChangeOtp}>
          {otpEnabled ? t('translation:reset') : t('translation:enable')}
        </BaseButton>
      </div>
    </BasePlate>
  );
};
